/**
 * Removes common prefixes (ClientBudget, SubscriptionBudget, PostpaidBudget) from event type
 */
function removeEventTypePrefix(eventType: string): string {
  return eventType.replace(
    /^(ClientBudget|SubscriptionBudget|Postpaid(?=Budget))/i,
    "",
  );
}

/**
 * Normalizes event type by removing prefixes for matching against BudgetEventType enum values
 * Keeps the Event suffix for matching
 */
export function normalizeEventType(eventType: string): string {
  return removeEventTypePrefix(eventType);
}

/**
 * Gets the translated event type name, returning the raw event type if translation doesn't exist.
 * This makes missing translations visible and forces proper maintenance.
 * @param eventType - The event type string (e.g., "PostpaidBudgetCampaignInvoicedEvent")
 * @param t - The i18next translation function
 * @returns The translated event type name or the raw event type if translation is missing
 */
export function getTranslatedEventTypeName(
  eventType: string,
  t: (key: string) => string,
): string {
  const translationKey = `eventTypes.${eventType}`;
  const translated = t(translationKey);

  // If translation doesn't exist, return the raw event type
  // This makes missing translations visible and forces proper maintenance
  if (translated === translationKey) {
    return eventType;
  }

  return translated;
}
